import useAuth from "../../hooks/useAuth";

export default () => {
  useAuth();
  return <></>;
};
